class HyrosUltraCart {
  constructor(config = {}) {
    const windowConfig = window?.hyrosConfig || {};
    this.config = {
      debug: this.debugSettingFound() || this.testOrderDetected(),
      accountId: '209644',
      pixelHash: 'a7f7ced7bb9df4f93103d098969138904aa10dce7ebdf5cf51e2dc80e4255cc0',
      version: '1.0.1',
      ...windowConfig,
      ...config
    };
    this.sdkInitializing = false;
    this.sdkInitialized = false;
    this.init();
  }

  log(message, ...args) {
    if (this.config.debug) {
      console.log(`Hyros: ${message}`, ...args);
    }
  }

  init() {
    this.log('UltraCart Plugin Initialized');
    this.loadHyrosSDK();
  }

  setup() {
    this.setupEventListeners();
  }

  loadHyrosSDK() {
    if (this.sdkInitializing || this.sdkInitialized || !this.config.accountId) return;

    this.sdkInitializing = true;
    const accountId = this.config.accountId;
    const pixelHash = this.config.pixelHash;

    const head = document.head;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://${accountId}.t.hyros.com/v1/lst/universal-script?ph=${pixelHash}&tag=!clicked&ref_url=${encodeURI(document.URL)}`;
    head.appendChild(script);

    this.whenDefined('hrs', () => {
      this.sdkInitialized = true;
      this.sdkInitializing = false;
      this.log('SDK Initialized');
      this.setup();
    });
  }

  setupEventListeners() {
    // TODO: Add UltraCart specific event listeners
  }

  testOrderDetected() {
    return window?.ucTestOrder ?? false;
  }

  debugSettingFound() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('hy_debug') || false;
  }

  setDebug(enabled) {
    this.config.debug = enabled;
    if (enabled) {
      this.log('Debug mode enabled');
    }
  }

  whenDefined(variableName, callback, timeout = 10000, logError = true) {
    const getNestedProperty = (obj, path) => {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    let cachedValue = getNestedProperty(window, variableName);
    if (cachedValue !== undefined) {
      callback(cachedValue);
      return;
    }

    const intervalId = setInterval(() => {
      if (cachedValue !== undefined) {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
        callback(cachedValue);
        return;
      }

      cachedValue = getNestedProperty(window, variableName);
      if (cachedValue !== undefined) {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
        callback(cachedValue);
      }
    }, 10);

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      if (logError) {
        console.error(`whenDefined: Timeout after ${timeoutSeconds} seconds waiting for ${variableName} to be defined.`);
      }
    }, timeout);
  }
}

export default HyrosUltraCart;

// Add auto-initialization code
const windowConfig = window?.hyrosConfig || {};
if (windowConfig.accountId && !window.hyp) {
  window.hyp = new HyrosUltraCart(windowConfig);
}
